import LoginHeader from "components/LoginHeader";
import React from "react";
import { Grid, useMediaQuery } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { createUseStyles } from "react-jss";
import { useHistory } from "react-router-dom";
import Background from "img/Background.png";
import ForwardIcon from "components/ForwardIcon";
import { getCurrentYear } from "utility/date";

const useStyles = createUseStyles({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

const Logout = () => {
  const classes = useStyles();

  const { t } = useTranslation();

  const matchesMediaQuery = useMediaQuery("(min-width: 600px)");

  const history = useHistory();

  return (
    <div
      style={{
        backgroundImage: `url(${Background})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        width: "100%",
        height: "100%",
      }}
    >
      <LoginHeader />
      <div
        className={classes.container}
        style={{
          height: matchesMediaQuery
            ? "calc(100% - 270px)"
            : "calc(100% - 230px)",
        }}
      >
        <div
          style={{
            width: matchesMediaQuery ? "58%" : "100%",
            height: 500,
            maxWidth: 750,
            textAlign: "center",
          }}
        >
          <p style={{ color: "#4B7E17", fontSize: "1.9em" }}>
            {t("logout_successful")}
          </p>
          <button
            onClick={() => {
              history.push("/login");
            }}
            style={{
              fontSize: "1.125em",
              background: "transparent",
              border: "none",
              textTransform: "uppercase",
              color: "#ffffff",
              cursor: "pointer",
              outline: "none",
              letterSpacing: "0.09375em",
            }}
          >
            {t("login_again")}
            <ForwardIcon />
          </button>
        </div>
      </div>
      <Grid
        container
        style={{
          height: 47,
          background: "#1A1A1A",
        }}
      >
        <Grid
          item
          xs={12}
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            style={{
              color: "#666666",
              textAlign: "center",
              fontSize: "min(max(.7em, 3vw), 1em)",
              margin: 0,
            }}
          >
            © {getCurrentYear()} Forea Capital Oy. All rights reserved.
            {matchesMediaQuery ? " | " : <br />}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://forea.fi/wp-content/uploads/BEST-EXECUTION-2019.pdf"
              style={{ color: "#666666", textDecoration: "none" }}
            >
              Best Execution (in Finnish){" "}
            </a>{" "}
            |{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://forea.fi/wp-content/uploads/Tietoja-ForeaCapitalOy.pdf"
              style={{ color: "#666666", textDecoration: "none" }}
            >
              Customer Information (in Finnish){" "}
            </a>
          </p>
        </Grid>
      </Grid>
    </div>
  );
};

export default React.memo(Logout);
